import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { useToast } from '../../hooks/use-toast';

const STATUSES = [
  { key: 'queued', label: 'Queued' },
  { key: 'in_kitchen', label: 'In Kitchen' },
  { key: 'ready', label: 'Ready' },
  { key: 'out_for_delivery', label: 'Out for Delivery' },
  { key: 'completed', label: 'Completed' },
];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const { toast } = useToast();
  const load = () => api.get('/admin/orders').then((r) => setOrders(r.data));
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);

  const setStatus = async (id, kitchenStatus) => {
    try {
      await api.post(`/admin/orders/${id}/status`, { kitchenStatus });
      toast({ title: 'Status updated', description: STATUSES.find((s) => s.key === kitchenStatus)?.label });
      load();
    } catch (err) {
      toast({ title: 'Error', description: err?.response?.data?.detail || 'Update failed' });
    }
  };

  return (
    <div>
      <h1 className="font-heading font-bold text-3xl text-[#0F1C2E] mb-6">Orders</h1>
      <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
        {orders.length === 0 ? <div className="p-8 text-center text-gray-400 text-sm">No orders yet</div> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-[#FDF3EC] text-[#0F1C2E]">
                <tr>
                  <th className="text-left px-5 py-3">Order</th>
                  <th className="text-left px-5 py-3">Customer</th>
                  <th className="text-left px-5 py-3">Items</th>
                  <th className="text-left px-5 py-3">Total</th>
                  <th className="text-left px-5 py-3">Kitchen Status</th>
                  <th className="text-left px-5 py-3">Type / When</th>
                  <th className="text-left px-5 py-3">Placed</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((o) => {
                  const paid = o.status === 'paid';
                  return (
                    <tr key={o.id} className="border-t border-gray-50">
                      <td className="px-5 py-3 font-mono text-xs">{o.id.slice(0, 8)}</td>
                      <td className="px-5 py-3">
                        <div className="font-semibold">{o.customerName}</div>
                        <div className="text-xs text-gray-500">{o.customerPhone}</div>
                      </td>
                      <td className="px-5 py-3 text-gray-700 max-w-xs">
                        <div className="line-clamp-2">{o.items?.map((i) => `${i.qty}× ${i.name}`).join(', ')}</div>
                      </td>
                      <td className="px-5 py-3 font-semibold text-[#ED2E2E]">${o.total.toFixed(2)}</td>
                      <td className="px-5 py-3">
                        {!paid ? (
                          <span className={`text-xs px-2 py-1 rounded-full font-semibold ${o.status === 'payment_failed' ? 'bg-red-50 text-red-700' : 'bg-yellow-50 text-yellow-700'}`}>{o.status}</span>
                        ) : (
                          <select value={o.kitchenStatus || 'queued'} onChange={(e) => setStatus(o.id, e.target.value)} className="text-xs px-2 py-1 rounded-lg border border-gray-200 bg-white font-semibold focus:outline-none focus:border-[#ED2E2E]">
                            {STATUSES.map((s) => <option key={s.key} value={s.key}>{s.label}</option>)}
                          </select>
                        )}
                      </td>
                      <td className="px-5 py-3">
                        <div className="text-xs text-gray-700 font-semibold">{o.type === 'delivery' ? 'Delivery' : 'Pickup'}</div>
                        {o.scheduledFor ? (
                          <div className="text-xs mt-1 text-[#ED2E2E] font-semibold">{new Date(o.scheduledFor).toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}</div>
                        ) : <div className="text-xs mt-1 text-gray-400">ASAP</div>}
                        {o.delivery?.tracking_url && <a href={o.delivery.tracking_url} target="_blank" rel="noopener noreferrer" className="text-xs text-[#ED2E2E] font-semibold hover:underline">Track ↗</a>}
                      </td>
                      <td className="px-5 py-3 text-gray-500 text-xs">{new Date(o.created_at).toLocaleString()}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
